<div class="menuDisplayedColumns">
  <button mat-mini-fab matTooltip="Préférences des colonnes" [matMenuTriggerFor]="menu" color="primary">
    <mat-icon>list</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <div cdkDropList (cdkDropListDropped)="onMooveColumnsOrder($event)">
      <div *ngFor="let displayedColumn of roleFilterdColumn" cdkDrag>
        <section class="menu-item" (click)="$event.stopPropagation()">
          <ng-container *ngIf="displayedColumn.editable">
            <mat-checkbox class="example-margin" [checked]="displayedColumn.visible" (change)="
                onSelectColumnVisibility({
                  name: displayedColumn.name,
                  checked: $event.checked
                })
              ">
              {{ displayedColumn.title | translate }}
            </mat-checkbox>
          </ng-container>
        </section>
      </div>
    </div>
  </mat-menu>
</div>